import { Profile } from "../global"

export const getStoredProfile = (): Profile | undefined => {
  const currentProfile = localStorage.getItem("currentProfile")
  try {
    return currentProfile ? JSON.parse(currentProfile) : undefined
  } catch (error) {
    localStorage.removeItem("currentProfile")
    return undefined
  }
}

const hasGroup = (profile: Profile | undefined | null, groupName: string) => {
  const groups = (profile?.groups || []) as Array<string | { name?: string }>
  return groups.some((group) => {
    if (typeof group === "string") {
      return group === groupName
    }
    return (group as { name?: string }).name === groupName
  })
}

export const canManageSpecialistEvaluations = (
  profile: Profile | undefined | null
) => {
  return !!profile && (profile.is_staff || hasGroup(profile, "Tutors"))
}
